import Vue from 'vue'
import './main.css'

import Header from './components/Header.vue'
import Footer from './components/Footer.vue'

import NotFound from './pages/error/NotFound.vue'
import Home from './pages/Home.vue'
import AboutMe from './pages/AboutMe.vue'
import ContactMe from './pages/ContactMe.vue'
import Login from './pages/Login.vue'
import Dashboard from './pages/auth/Dashboard.vue'
import Payment from './pages/Payment.vue'
import Category from './pages/Category.vue'
import ProgramDetail from './pages/auth/ProgramDetail.vue'
import VideoList from './pages/auth/VideoList.vue'
import InviteFriend from './pages/auth/InviteFriend.vue'
import TermsAndConditions from './pages/Terms.vue'
import Cookies from './pages/Cookies.vue'
import Privacy from './pages/Privacy.vue'
import ResetPassword from './pages/ResetPassword.vue'
import Subscribe from './pages/Subscribe.vue'

import { THEMEMASCOT } from '..//public/js/custom.js';

import Axios from 'axios'

Vue.prototype.$http = Axios;

Axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response.data.statusCode === 401) {
    localStorage.removeItem('token')
    delete Vue.prototype.$http.defaults.headers.common['Authorization'];
    window.location.replace("/");
  }
  return Promise.reject(error)
});

const token = localStorage.getItem('token');

if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer ' + token
}
else{
  delete Vue.prototype.$http.defaults.headers.common['Authorization'];
}

Vue.config.productionTip = false;

const routes = [
  {
    Path: '',
    Component: Home,
    VerifyAuth: false
  },
  {
    Path: '/',
    Component: Home,
    VerifyAuth: false
  },
  {
    Path: '/aboutme',
    Component: AboutMe,
    VerifyAuth: false
  },
  {
    Path: '/contactme',
    Component: ContactMe,
    VerifyAuth: false
  },
  {
    Path: '/login',
    Component: Login,
    VerifyAuth: false
  },
  {
    Path: '/dashboard',
    Component: Dashboard,
    VerifyAuth: true
  },
  {
    Path: '/payment',
    Component: Payment,
    VerifyAuth: false
  },
  {
    Path: '/category',
    Component: Category,
    VerifyAuth: false
  },
  {
    Path: '/programdetail',
    Component: ProgramDetail,
    VerifyAuth: true
  },
  {
    Path: '/videos',
    Component: VideoList,
    VerifyAuth: true
  },
  {
    Path: '/invite-friend',
    Component: InviteFriend,
    VerifyAuth: true
  },
  {
    Path: '/terms',
    Component: TermsAndConditions,
    VerifyAuth: false
  },
  {
    Path: '/cookies',
    Component: Cookies,
    VerifyAuth: false
  },
  {
    Path: '/privacy',
    Component: Privacy,
    VerifyAuth: false
  },
  {
    Path: '/resetpass',
    Component: ResetPassword,
    VerifyAuth: false
  },
  {
    Path: '/subscribe',
    Component: Subscribe,
    VerifyAuth: false
  }
]

new Vue({
  el: '#app',
  data: {
    currentRoute: window.location.pathname
  },
  computed: {
    ViewComponent() {
      // if (this.currentRoute.includes('category')) {
      //   var routeCategory = routes.filter(x =>  x.Path.toLowerCase() == '/category')[0];
        
      //   return routeCategory.Component;
      // }

      if (routes.some(x => this.currentRoute.toLowerCase() == x.Path.toLowerCase())) {
        console.log(localStorage.getItem('token'));
        var routeSelected = routes.filter(x => this.currentRoute.toLowerCase() == x.Path.toLowerCase())[0];
        console.log(routeSelected);
        if (routeSelected.VerifyAuth) {
          if (token != null) {
            return routeSelected.Component;
          }
          else {
            //REDIRECT TO LOGIN
            window.location.replace("/login");
          }
        }
        return routeSelected.Component;
      }
      else {
        return NotFound;
      }
    },
    PropsComponents() {
      var urlParams = new URLSearchParams(window.location.search);

      if (urlParams.has('ID')) {
        return {
          props: {
            ID: urlParams.get('ID')
          }
        };
      }
      if (urlParams.has('Key')) {
        return {
          props: {
            CategoryKey: urlParams.get('Key')
          }
        };
      }
      
      if (urlParams.has('Token')) {
        return {
          props: {
            PassToken: urlParams.get('Token')
          }
        };
      }
      // else if (this.currentRoute.toLowerCase().includes('category')) {
      //   var pathRoutes = window.location.pathname.split('/');
      //   console.log(pathRoutes)
      //   return {
      //     props: {
      //       CategoryKey: pathRoutes[pathRoutes.length - 1]
      //     }
      //   };
      // }

      return null;
    }
  },
  render(createElement) {
    return createElement('div', [
      createElement(Header),
      createElement(this.ViewComponent, this.PropsComponents),
      createElement(Footer)
    ])
  },
  mounted() {
    THEMEMASCOT.windowOnLoad.init();

    THEMEMASCOT.initialize.init();
    THEMEMASCOT.header.init();
    THEMEMASCOT.windowOnscroll.init();
  }
})




Date.prototype.toReadableString = function() {
  var mm = this.getMonth() + 1;
  var dd = this.getDate();

  return [(dd>9 ? '' : '0') + dd, 
          (mm>9 ? '' : '0') + mm,
          this.getFullYear(),
          '-',
          this.getHours(),
          this.getMinutes(),
          this.getSeconds(),
         ].join('');
};
